export default "__VITE_ASSET__g4FJVI04__"